module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/commissioni-agente.3b11c7889338e4e32f36c308ddd5ec1a.jpg";